//default from angular libraries
import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';

//import services
import { SuperAdminService } from '../../../services/superadmin.service';
import { AppFrontRoutes } from 'src/app/constants/app-front-routes';

@Component({
  selector: 'app-super_admin_user_details',
  templateUrl: './super_admin_user_details.component.html',
  styleUrls: ['./super_admin_user_details.component.css'],
  host: {'id': 'content'},
  providers: [SuperAdminService]
})

export class SuperAdminUserDetailsComponent implements OnInit {
    id:string = ""
    userdata:any;
    readonly AppFrontRoutes = AppFrontRoutes;
  	constructor(
          private route: ActivatedRoute,
          private router: Router,
          private superadminService : SuperAdminService  
    ) { }

  	ngOnInit() {
        this.id = this.route.snapshot.paramMap.get('id');
        this.getUserData(this.id)
    }
    
    getUserData(userid){
        this.superadminService.getUserDetail(userid).subscribe(
            (res) => {
                console.log(res)
                if(res.status){                    
                    this.userdata = res.data.user_data
                }
            }
        );
    }

}
